import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { EdpContractConsumptionLocalModule } from "@edp-components/edp-contract-consumption-local/edp-contract-consumption-local.module";
import { TranslateModule } from "@ngx-translate/core";
import { EdpESidebarSubLevelComponent } from "./edp-e-sidebar-sub-level.component";
import { ExternalLinkModule } from "@edp-directives/external-link/external-link.module";
import { EdpEsContractConsumptionLocalModule } from "@edp-components/ES/edp-es-contract-consumption-local/edp-es-contract-consumption-local.module";
import { ConditionalRegionModule } from "@edp-directives/conditional-region/conditional-region.module";

@NgModule({
    declarations: [EdpESidebarSubLevelComponent],
    imports: [
        CommonModule,
        TranslateModule,
        EdpContractConsumptionLocalModule,
        EdpEsContractConsumptionLocalModule,
        RouterModule,
        ExternalLinkModule,
        ConditionalRegionModule
    ],
    exports: [EdpESidebarSubLevelComponent],
})
export class EdpESidebarSubLevelModule {}
